import { observer } from 'mobx-react-lite'
import { type JobListViewModel } from './JobListViewModel'
import { JobItemContainer } from '@/features/jobs/details/components/JobList/JobItem/JobItemContainer'
import { JobListHeaderContainer } from './JobListHeaderContainer'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { ScrollView } from '@/components/ScrollView'
import { JobListEmptyContainer } from '@/features/jobs/details/components/JobList/JobListEmpty/JobListEmptyContainer'

export interface JobListContainerProps {
  vm: JobListViewModel
}

export const JobListContainer = observer(function JobListContainer({
  vm,
}: JobListContainerProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()
  return (
    <Sandwich stretch>
      <SandwichBun>
        <JobListHeaderContainer vm={vm} scrollOffset={scrollOffset} />
      </SandwichBun>
      <SandwichContent>
        {vm.fetch.match({
          pending: () => <ContentLoading />,
          rejected: (err) => <ContentError error={err} />,
          resolved: () => (
            <ScrollView ref={scrollRef}>
              {vm.showEmptyState && <JobListEmptyContainer vm={vm} />}
              {vm.jobs.map((jobItem) => (
                <JobItemContainer vm={jobItem} key={jobItem.job.id} />
              ))}
              <InfiniteScrollLoaderContainer
                scrollProvider={vm.searcher.scroller}
              />
            </ScrollView>
          ),
        })}
      </SandwichContent>
    </Sandwich>
  )
})
